import React, { useState, useEffect } from "react";
import { Table, Pagination, Spin, Divider } from "antd";
import { es } from "date-fns/locale/es";
import { Controller, useForm } from "react-hook-form";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import reportServices from "../../services/supervision-report-service";
import supervisionService from "../../services/supervision-service";
import farmService from "../../services/farm-service";
import lotService from "../../services/lot-service";
import userService from "../../services/user-service";
import sectionService from "../../services/section-service";
import moment from "moment";
import config from "../../config/config";
import { ToastContainer, toast } from 'react-toastify';

import DatePicker from "react-datepicker";

const SupervisionReport = () => {

  registerLocale("es", es);
  const start_date = moment().add(-config.DAYS_LESS_MAP, 'd').startOf("day").toDate();
  const end_date = moment().endOf("day").toDate();
  const [startDate, setStartDate] = useState(start_date);
  const [endDate, setEndDate] = useState(end_date);

  const escoja = [{ _id: 0, name: "-ESCOJA-" }];
  const [listFarms, setListFarms] = useState(escoja);
  const [listLots, setListLots] = useState(escoja);
  const [listSection, setListSection] = useState(escoja);
  const [listUsers, setListUsers] = useState(escoja);

  ///Aplicaciones por dia
  const [farmId, setFarmId] = useState("0");
  const [sectionId, setSectionId] = useState("0");
  const [lotId, setLotId] = useState("0");


  const [initReport, setInitReport] = useState(false);


  const yesNoList = [
    { id: true, name: "SI" },
    { id: false, name: "NO" },
  ];


  const {
    register,
    getValues,
    setValue,
    control,
    formState: { errors },
  } = useForm();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);


  const getUserList = async () => {
    let listado = await userService.getListByRol("OPERADOR");
    if (listado) {
      listado.push({ _id: 0, name: "-ESCOJA-" });
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListUsers(sortedItems);
      //setValue("farm",0)
    }
  };


  const getLisFarm = async () => {
    let listado = await farmService.getList();
    if (listado) {
      listado.push({ _id: 0, name: "-ESCOJA-" });
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListFarms(sortedItems);
    }
  };

  const getListSection = async (e) => {
    const code = e.target.value;
    if (code == "0") {
      setListSection(escoja);
      setListLots(escoja);
      setValue("section", "0")
      setValue("lot", "0")
      setValue("user", "0")
      return;
    }
    let listado = await sectionService.getListByFarm(code);
    listado.push({ _id: 0, name: "-ESCOJA-" });
    if (listado) {
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListSection(sortedItems);
      setValue("section", "0")
      setValue("lot", "0")
      setValue("user", "0")
    }
  };



  const getLisLots = async (e) => {
    const code = e.target.value;
    if (code == "0") {
      setListLots(escoja);
      setValue("lot", "0")
      setValue("user", "0")
      return;
    }
    let listado = await lotService.getListBySection(code);
    listado.push({ _id: 0, name: "-ESCOJA-" });
    if (listado) {
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListLots(sortedItems);
      setValue("lot", "0")
      setValue("user", "0")
    }
  };






  const generateExcel = async () => {
    setInitReport(true)

    let start = moment(startDate).startOf("day").format('YYYY-MM-DD');
    let end = moment(endDate).endOf("day").format('YYYY-MM-DD');
    setLoading(true);
    try {
      const farmId = getValues("farm")
      const sectionId = getValues("section")
      const lotId = getValues("lot")
      const userId = getValues("user")
      const updated = getValues("updated")
      const response = await reportServices.supervisionExcel(start, end, farmId, sectionId, lotId, userId,updated);
      if (response?.error) {
        toast.error("No hay registros", { autoClose: 1600 })
        return;
      }
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `datos-supervision ${start} - ${end}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();

    } catch (error) {
      console.error("Error al obtener los movimientos:", error);
    } finally {
      setLoading(false);
    }
  }










  const searchMovements = async (page, pageSize) => {
    setInitReport(true)
    let start = moment(startDate).startOf("day").format('YYYY-MM-DD');
    let end = moment(endDate).endOf("day").format('YYYY-MM-DD');
    setLoading(true);
    try {
      const farmId = getValues("farm")
      const sectionId = getValues("section")
      const lotId = getValues("lot")
      const userId = getValues("user")
      const updated = getValues("updated")
      setPage(1);

      await supervisionService.synchronizePending(start, end, farmId, sectionId, lotId, userId)
      const params = {page:1,limit:pageSize,startDate:start, endDate:end,farmId,sectionId,lotId,userId,updated}
      const response = await reportServices.supervisionReport(params);
      setData(response.data);
      setTotal(response.total);
    } catch (error) {
      console.error("Error al obtener los movimientos:", error);
    } finally {
      setLoading(false);
    }
  }

  const fetchMovements = async (page, pageSize) => {
    if (!initReport) return;
    let start = moment(startDate).startOf("day").format('YYYY-MM-DD');
    let end = moment(endDate).endOf("day").format('YYYY-MM-DD');
    const farmId = getValues("farm")
    const sectionId = getValues("section")
    const lotId = getValues("lot")
    const userId = getValues("user")
    const updated = getValues("updated")
    setLoading(true);
    try {
      const params = {page,limit:pageSize,startDate:start, endDate:end,farmId,sectionId,lotId,userId,updated}
      const response = await reportServices.supervisionReport(params);
      setData(response.data);
      setTotal(response.total);
    } catch (error) {
      console.error("Error al obtener los movimientos:", error);
    } finally {
    }
    setLoading(false);
  };


  useEffect(() => {
    fetchMovements(page, pageSize);
  }, [page, pageSize]);



  useEffect(() => {
    getLisFarm();
    getListFilterUsers()
  }, []);



  const getListFilterUsers = async () => {
    const userId = "0"
    try {
      let start = moment(startDate).startOf("day").format('YYYY-MM-DD');
      let end = moment(endDate).endOf("day").format('YYYY-MM-DD');
      const response = await userService.listInSupervision(start, end, farmId, sectionId, lotId)
      const listado = response.data
      if (listado) {
        listado.push({ _id: 0, name: "-ESCOJA-" });
        const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
        setListUsers(sortedItems);
      }
    } catch (error) { }
  }
  useEffect(() => {
    getListFilterUsers();
  }, [startDate, endDate, sectionId, farmId, lotId]);




  const handlePageChange = (page, pageSize) => {
    setPage(page);
    setPageSize(pageSize);
  };


  return (
    <div className="row p-4">
      <ToastContainer />
      <div className="col-12 " style={{ marginTop: "-10px" }}>
        <Divider orientation="left" style={{ border: "#AAAAAA" }} >Reporte detallado de supervisión</Divider>
      </div>

      <div className="col-12">
        <form className="form-react">
          <div className="row mb-3">
            <div className="col-12 col-sm-10">
              <div className="row">

                <div className=" col-12 col-sm-4 ">
                  <label className="text-secondary fw-bold">Finca</label>
                  <select
                    className="form-control text-secondary"
                    {...register("farm")}
                    onChange={(e) => {
                      getListSection(e)
                      const value = e.target.value
                      setFarmId(value)
                    }}
                  >
                    {listFarms.map((option) => (
                      <option key={option._id} value={option._id}>
                        {option.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-12 col-sm-4 ">
                  <label className="text-secondary fw-bold">Sección</label>
                  <select
                    className="form-control text-secondary"
                    {...register("section")}
                    onChange={(e) => {
                      getLisLots(e)
                      const value = e.target.value
                      setSectionId(value)
                    }}
                  >
                    {listSection.map((option) => (
                      <option key={option._id} value={option._id}>
                        {option.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-12 col-sm-4 ">
                  <label className="text-secondary fw-bold">Lote</label>
                  <select
                    className="form-control text-secondary"
                    {...register("lot")}
                    onChange={(e) => {
                      setValue("user", "0")
                      const value = e.target.value
                      setLotId(value)

                    }}
                  >
                    {listLots.map((option) => (
                      <option key={option._id} value={option._id}>
                        {option.name}
                      </option>
                    ))}
                  </select>
                </div>



                <div className="col-6 col-sm-2">
                  <label className="text-secondary fw-bold">Desde</label>
                  <br />
                  <Controller
                    control={control}
                    name="startDate"
                    defaultValue={startDate}
                    render={({ field }) => (
                      <DatePicker
                        {...field}
                        locale="es"
                        dateFormat="yyyy-MM-dd"
                        className="form-control text-secondary"
                        selected={field.value}
                        onChange={(date) => {
                          field.onChange(date);
                          setStartDate(date)
                          const endOfMonth = moment(date).endOf("day").toDate();
                          setValue("endDate", endOfMonth);
                          setEndDate(endOfMonth);
                        }}
                      />
                    )}
                  />
                </div>

                <div className="col-6 col-sm-2">
                  <label className="text-secondary fw-bold">Hasta</label>
                  <br />
                  <Controller
                    control={control}
                    name="endDate"
                    defaultValue={endDate}
                    render={({ field }) => (
                      <DatePicker
                        {...field}
                        locale="es"
                        dateFormat="yyyy-MM-dd"
                        className="form-control text-secondary"
                        selected={field.value}
                        onChange={(date) => {
                          field.onChange(date)
                          const endOfDay = moment(date).endOf("day").toDate();
                          setValue("endDate", endOfDay);
                          setEndDate(endOfDay);
                        }
                        }
                      />
                    )}
                  />
                </div>

                <div className="col-12 col-sm-4">
                  <label className="text-secondary fw-bold">Usuario</label>
                  <select
                    className="form-control text-secondary"
                    {...register("user")}
                    onChange={(e) => {
                      const value = e.target.value;
                    }}
                  >
                    {listUsers.map((option) => (
                      <option key={option._id} value={option._id}>
                        {option.name}
                      </option>
                    ))}
                  </select>
                </div>



                <div className="col-12 col-sm-4">
                  <label className="text-secondary fw-bold">Estado</label>
                  <select className="form-control text-secondary" {...register("updated")}>
                    <option value="true">EMPAREJADOS</option>
                    <option value="false">PENDIENTE DE EMPAREJAR</option>
                  </select>
                </div>


              </div>
            </div>


            <div className="col-12 col-sm-2">

              <div className=" col-12">
                <label className="text-secondary fw-bold">&nbsp;</label>
                <br />
                <Spin spinning={loading}>
                  <button
                    className="btn btn-primary w-100"
                    type="button"
                    onClick={() => searchMovements(page, pageSize)}
                  >
                    <i className="bi bi-search fa-lg m-2" /> Buscar
                  </button>
                </Spin>
              </div>

              <div className=" col-12">
                <label className="text-secondary fw-bold">&nbsp;</label>
                <br />
                <Spin spinning={loading}>
                  <button
                    className="btn btn-success w-100"
                    type="button"
                    onClick={() => generateExcel()}
                  >
                    <i className="bi bi-file-earmark-text fa-lg m-2" /> Exportar
                  </button>
                </Spin>
              </div>

            </div>
          </div>
        </form>
      </div>

      <Pagination
        className="text-primary "
        current={page}
        pageSize={pageSize}
        total={total}
        onChange={handlePageChange}
        pageSizeOptions={["10", "20", "50"]}
        showTotal={(total) => `Total ${total} registros`}
        showSizeChanger
        onShowSizeChange={(current, size) => handlePageChange(1, size)}
      />
      <Spin spinning={loading}>
        <div className="card mt-3" style={{ minHeight: "400px" }}>

          <div className="table-responsive">
            <table className="table">
              <thead className="table-primary">
                <tr valign="middle">
                  <th>Fecha</th>
                  <th>Usuario</th>
                  <th>Supervisor</th>
                  <th>Finca</th>
                  <th>Sección</th>
                  <th>Lote</th>
                  <th>Línea</th>
                  <th>Palma</th>
                  <th>Flores<br />aptas</th>
                  <th>Flores<br />polinizadas</th>
                  <th>Flores<br />Reportadas</th>
                  <th>Confiable</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, index) => (
                  <tr key={index}>
                    <td>{item.date.split("T")[0]}</td>
                    <td>
                      {item.multipleOperators
                        ? item.duplicateOperators.map((a, index) => (
                          <React.Fragment key={index}>
                            {a.userName}
                            <br />
                          </React.Fragment>
                        ))
                        : item.operatorName
                      }
                    </td>
                    <td>{item.userName}</td>
                    <td>{item.farmName}</td>
                    <td>{item.sectionName}</td>
                    <td>{item.lotName}</td>
                    <td>{item.lineName}</td>
                    <td>{item.palmName}</td>
                    <td>{item.bunches}</td>
                    <td>{item.applications}</td>
                    <td>{item.bunchesReported}</td>
                    <td>{item.trusted == 1 ? "SI" : "NO"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </Spin>
    </div>
  );
};


export default SupervisionReport;
